<template>
  <div class="app-container">
    <div style="margin-bottom: 10px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/company/add')"
        >添加企业</el-button
      >
      <el-button
        size="medium"
        type="danger"
        @click="delCompany('batch')"
        v-if="roles.includes('/company/del')"
        >删除企业</el-button
      >
      <el-button
        size="medium"
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company/company_template')"
        >下载模板</el-button
      >
      <el-button
        size="medium"
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/company/import')"
        >导入</el-button
      >
    </div>
    <div class="head">
      <!-- <el-select
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入企业名称"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.legal_name"
        placeholder="请输入法人姓名"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.legal_phone"
        placeholder="请输入法人电话"
        maxlength="11"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.company_mobile"
        placeholder="请输入公司电话"
        maxlength="11"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.company_contacts"
        placeholder="请输入公司联系人"
      ></el-input>
      <div class="btn">
        <el-button
          size="medium"
          type="primary"
          @click="(screen.page = 1), fetchData()"
          >筛选</el-button
        >
        <el-button size="medium" type="primary" plain @click="chongZhi()"
          >重置</el-button
        >
      </div>
    </div>

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="公司名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属园区" align="center">
        <template slot-scope="scope">
          {{ scope.row.park ? scope.row.park.name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="法人姓名" align="center">
        <template slot-scope="scope">
          {{ scope.row.legal_name }}
        </template>
      </el-table-column>
      <el-table-column label="法人电话" align="center">
        <template slot-scope="scope">
          {{ scope.row.legal_phone }}
        </template>
      </el-table-column>
      <el-table-column label="公司联系人" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.company_contacts }}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司电话" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.company_mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <div>
            <el-button
              size="mini"
              type="warning"
              @click="handleSee(scope.row)"
              v-if="roles.includes('/company/info')"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="handleEdit(scope.row)"
              v-if="roles.includes('/company/edit')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="delCompany('single', scope.row.id)"
              v-if="roles.includes('/company/del')"
              >删除</el-button
            >
          </div>
          <div style="margin-top: 10px">
            <el-button
              size="mini"
              type="success"
              @click="seeUser(scope.row)"
              v-if="roles.includes('/company/user_lists')"
              >员工列表</el-button
            >

          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="cztype == 'see'"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司类型" prop="status">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype == 'see'">
            <el-radio :label="1">企业</el-radio>

            <el-radio :label="2">园区</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="接收账单人员" prop="accept_msg_user_id">
          <el-select
            filterable
            v-model="ruleForm.accept_msg_user_id"
            placeholder="请选择人员"
            :disabled="cztype != 'edit'"
            multiple
            collapse-tags
            remote
            :remote-method="remoteMethod"
            :loading="loading"
            @visible-change="handleVisibleChange"
            @focus="handleFocus"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in msgUserList"
              :key="index"
            ></el-option>
            <!-- 加载更多选项 -->
            <div v-if="hasMore" class="load-more-option" @click="loadMore">
              <div v-if="loadingMore" class="loading-text">
                <el-icon class="is-loading"><Loading /></el-icon>
                加载中...
              </div>
              <div v-else class="load-more-text">点击加载更多</div>
            </div>

            <!-- 无更多数据提示 -->
            <div
              v-if="!hasMore && msgUserList.length > 0"
              class="no-more-option"
            >
              没有更多数据了
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="法人姓名" prop="legal_name">
          <el-input
            v-model="ruleForm.legal_name"
            :disabled="cztype == 'see'"
            placeholder="请输入法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人电话" prop="legal_phone">
          <el-input
            maxlength="11"
            v-model="ruleForm.legal_phone"
            :disabled="cztype == 'see'"
            placeholder="请输入法人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司联系人" prop="company_contacts">
          <el-input
            v-model="ruleForm.company_contacts"
            :disabled="cztype == 'see'"
            placeholder="请输入公司联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="company_mobile">
          <el-input
            maxlength="11"
            v-model="ruleForm.company_mobile"
            :disabled="cztype == 'see'"
            placeholder="请输入公司电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司简介" prop="about">
          <Editor style="width: 100%" v-model="ruleForm.about" />
          <!-- <el-input  v-model="ruleForm.about" :disabled="cztype == 'see'" placeholder="请输入公司简介"></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      size="50%"
      title="企业用户"
      :visible.sync="userDrawer"
      direction="rtl"
      :before-close="handleClose"
      class="qyUser"
    >
      <el-button type="primary" @click="addQiYeUser()">添加</el-button>
      <el-table
        max-height="700"
        v-loading="listLoading"
        :data="userList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        row-key="id"
        :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (userScreen.page - 1) * userScreen.page_size + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column label="用户名" align="center">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column label="头像" align="center">
          <template slot-scope="scope">
            <img
              v-if="scope.row.avatar_url"
              class="tableIcon"
              alt=""
              srcset=""
              :src="imageOss + scope.row.avatar_url"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="200"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="seeUserInfo(scope.row.id)"
              v-if="roles.includes('/company/info')"
              >查看</el-button
            >
            <!-- <el-button
              size="mini"
              type="danger"
              @click="openUserRole(scope.row.id)"
              v-if="roles.includes('/company/user_del')"
              >查看角色</el-button
            > -->
            <!-- <el-button
            size="mini"
            type="danger"
            @click="userDelete(scope.row.id) && scope.row.id != userInfo.company_id"
            v-if="roles.includes('/company/del')"
            >删除</el-button
          > -->
          </template>
        </el-table-column>
        <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="userHandleSize"
        @current-change="userHandleCurrent"
        :current-page="userScreen.page"
        :page-sizes="[15, 30, 50]"
        :page-size="userScreen.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="userTotal"
        style="margin-top: 10px"
      >
      </el-pagination>
      <!-- 添加用户 -->
      <el-drawer
        size="600px"
        :title="userDrawerTitle"
        :visible.sync="addUserDrawer"
        direction="rtl"
        :append-to-body="true"
      >
        <el-form
          :model="userForm"
          :rules="userRules"
          ref="userForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="userForm.name"
              :disabled="userType == 'userSee'"
              placeholder="请输入账号名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            :prop="userType == 'add' ? 'password' : ''"
          >
            <el-input
              type="password"
              v-model="userForm.password"
              :disabled="userType == 'userSee'"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              maxlength="11"
              v-model="userForm.phone"
              :disabled="userType == 'userSee' || userType == 'userEidt'"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="头像" prop="icon">
            <el-upload
              :limit="1"
              ref="upload"
              name="file[]"
              :data="{ type: 'image' }"
              :action="ossUpload"
              :file-list="fileList"
              :headers="{ token: token }"
              list-type="picture-card"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccess"
              :disabled="userType == 'userSee'"
              :before-upload="beforeAvatarUpload"
              accept=".jpg,.png,.jpeg"
              :class="fileList.length > 0 ? 'hide' : ''"
            >
              <i class="el-icon-plus"></i> </el-upload
            ><!-- 已修改 -->
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group
              v-model="userForm.sex"
              :disabled="userType == 'userSee'"
            >
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
              <el-radio :label="3">保密</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input-number
              style="width: 202px"
              :disabled="userType == 'userSee'"
              :precision="0"
              v-model="userForm.age"
              :min="0"
              :max="300"
              label="年龄"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="学历" prop="education">
            <el-select
              filterable
              v-model="userForm.education"
              placeholder="请选择学历"
              :disabled="userType == 'userSee'"
            >
              <el-option
                :label="item.title"
                :value="item.value"
                v-for="(item, index) in educationList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="是否党员" prop="cpc">
            <el-radio-group
              v-model="userForm.cpc"
              :disabled="userType == 'userSee'"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">不是</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!-- <el-form-item label="人脸照片" prop="face_url">
            <el-upload
              :limit="1"
              ref="upload"
              name="file[]"
              :data="{ type: 'face' }"
              :action="ossUpload"
              :file-list="faceFileList"
              :headers="{ token: token }"
              list-type="picture-card"
              :on-remove="faceHandleRemove"
              :on-success="faceHandleAvatarSuccess"
              :disabled="userType == 'userSee'"
              :before-upload="faceBeforeAvatarUpload"
              accept=".jpg,.png,.jpeg"
              :class="faceFileList.length > 0 ? 'hide' : ''"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="pic-tips">
              人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
            </div>
          </el-form-item> -->
          <div>
            <el-form-item
              :label="'企业角色' + (index + 1)"
              v-for="(item, index) in domains"
              :key="index"
            >
              <el-select
                filterable
                class="w4"
                v-model="item.company_id"
                placeholder="请选择企业"
                disabled
              >
                <el-option
                  :label="item1.name"
                  :value="item1.id"
                  v-for="(item1, index1) in companyList"
                  :key="index1"
                ></el-option>
              </el-select>
              <!-- <el-select filterable  class="w4" v-model="item.system_role_id" placeholder="请选择角色" :disabled="item.company_id == '' || cztype == 'see'" >
              <el-option :label="item1.title" :value="item1.id" v-for="(item1,index1) in roleList" :key="index1"></el-option>
            </el-select> -->
              <el-cascader
                class="w4"
                placeholder="请选择角色"
                :disabled="item.company_id == '' || userType == 'userSee'"
                v-model="item.system_role_id"
                :options="roleList"
                :show-all-levels="false"
                @change="
                  (e) => {
                    roleChange(e, index);
                  }
                "
                :props="{
                  checkStrictly: true,
                  label: 'title',
                  value: 'id',
                  children: 'nodes',
                }"
                clearable
              ></el-cascader>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button
              v-if="userType == 'add'"
              type="primary"
              @click="submitUserForm('userForm')"
            >
              立即创建
            </el-button>
            <el-button
              v-if="userType == 'userSee'"
              type="primary"
              @click="
                userType = 'userEidt';
                userDrawerTitle = '编辑用户';
              "
            >
              编辑
            </el-button>
            <el-button
              v-if="userType == 'userEidt'"
              type="primary"
              @click="editUserForm('userForm')"
              >修改</el-button
            >
            <el-button type="info" @click="addUserDrawer = false">
              取消
            </el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </el-drawer>
    <el-dialog title="用户角色" :visible.sync="userRoleVisible">
      <el-table :data="userRoleData">
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="所属园区">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属企业">
          <template slot-scope="scope">
            <span v-if="scope.row.company">{{ scope.row.company.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            <span v-if="scope.row.system_role">{{
              scope.row.system_role.title
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="100"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              v-if="roles.includes('/company/user_del')"
              @click="handleDelete(scope.row)"
              >删除角色</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userRoleVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      @close="dialogClos"
      :close-on-click-modal="false"
      title="导入文件"
      :visible.sync="leadInVisible"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="baseURL + '/company/import'"
        :headers="{ token: token }"
        drag
        :limit="1"
        :on-success="handleAvatarSuccessFile"
        :on-progress="beforeAvatarUploadFile"
        :multiple="false"
        accept=".xlsx"
      >
        <!-- accept=".xlsx,.xls" -->
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
        <!-- ，且不超过500kb -->
      </el-upload>
      <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
      <div class="error" v-if="msgData.length > 0">
        <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="leadInVisible = false">取 消</el-button>
        <el-button type="primary" @click="leadInVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="企业画像"
      :visible.sync="trendVisible"
      width="1200px"
      :before-close="handleClose"
      class="trendDialog"
    >
      <div style="display: flex">
        <div
          class="tabBox"
          :class="trendPitch == 'user' ? 'pitch' : ''"
          @click="cut('user')"
        >
          员工增长趋势
        </div>
        <div
          class="tabBox"
          :class="trendPitch == 'visitor' ? 'pitch' : ''"
          @click="cut('visitor')"
        >
          访客趋势
        </div>
      </div>
      <div style="margin-top: 10px">
        <el-date-picker
          style="margin-right: 10px"
          v-model="trendForm.start_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="月份开始日期"
        >
        </el-date-picker>
        <el-date-picker
          style="margin-right: 10px"
          v-model="trendForm.end_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="月份结束日期"
        >
        </el-date-picker>
        <el-button
          size="medium"
          type="primary"
          @click="(screen.page = 1), screenTrend()"
          >搜索</el-button
        >
      </div>
      <div id="trendCharts" style="width: 100%; height: 300px"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trendVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { mapGetters } from "vuex";
import PaginationSelect from "@/components/paginationSelect/paginationSelect.vue";
import {
  companyList,
  addCompany,
  editCompany,
  delCompany,
  openPark,
  infoCompany,
  companyUser,
  delImage,
  openCompany,
  openRole,
  addCompanyUser,
  companyUserInfo,
  editCompanyUser,
  miniUserRole,
  delCompanyUser,
  company_template,
  get_space_lists,
  get_space_floor_lists,
  get_space_house_lists,
  companyUserTrend,
  visitorTrend,
} from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor, PaginationSelect },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      loading: false,
      loadingMore: false,
      pageParams: {
        page: 1,
        pageSize: 15,
        name: "",
        total: 0,
        id: "",
      },
      hasMore: true,
      userDrawer: false,
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加企业",
      token: getToken(),
      userScreen: {
        page: 1,
        page_size: 15,
        name: "",
        phone: "",
        id: "",
      },
      userTotal: 0,
      screen: {
        page: 1,
        page_size: 15,
        name: "",
        id: "",
        legal_name: "",
        company_mobile: "",
        company_contacts: "",
        legal_phone: "",
        park_id: "",
      },
      ruleForm: {
        name: "",
        park_id: "",
        legal_name: "",
        legal_phone: "",
        company_mobile: "",
        company_contacts: "",
        about: "",
        status: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        park_id: [
          { required: true, message: "请选择菜单类型", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        space: [
          {
            type: "array",
            required: true,
            message: "请选择楼栋",
            trigger: "change",
          },
        ],
        floor: [
          {
            type: "array",
            required: true,
            message: "请选择楼层",
            trigger: "change",
          },
        ],
        house: [
          {
            type: "array",
            required: true,
            message: "请选择房间",
            trigger: "change",
          },
        ],
      },
      userRules: {
        password: [
          {
            required: true,
            message: "请输入账号密码",
            trigger: "blur",
            min: "6",
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        // park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      oldImg: "",
      parkList: [],
      msgUserList: [],
      userList: [],
      // 添加企业用户
      qiyeInfo: {},
      addUserDrawer: false,
      userDrawerTitle: "添加用户",
      userType: "",
      userForm: {
        phone: "",
        name: "",
        company_role_data: "",
        status: 1,
        avatar_url: "",
        sex: 3,
        education: "",
        age: 0,
        face_url: "",
      },
      educationList: [
        {
          title: "小学",
          value: 2,
        },
        {
          title: "初中",
          value: 3,
        },
        {
          title: "高中",
          value: 4,
        },
        {
          title: "专科",
          value: 5,
        },
        {
          title: "本科",
          value: 6,
        },
        {
          title: "研究生",
          value: 7,
        },
        {
          title: "其他",
          value: 1,
        },
      ],
      roleList: [],
      companyList: [],
      domains: [{ park_id: "", company_id: "", system_role_id: "" }],
      userRoleVisible: false,
      userRoleData: [],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      fileList: [],
      loadProgress: 0,
      progressFlag: false,
      msgData: [],
      faceFileList: [],
      spaceList: [],
      floorList: [],
      houseList: [],
      trendVisible: false,
      trendPitch: "user",

      trendForm: {
        start_date: "",
        end_date: "",
        id: "",
      },
      selectedUser:[]
    };
  },
  created() {
    if (this.userInfo.company_id !== 0) {
      this.screen.id = this.userInfo.company_id;
    } else {
      this.screen.id = "";
    }

    // this.getpark();
    this.fetchData();
  },
  methods: {
    // 下拉框显示/隐藏
    handleVisibleChange(visible) {
      // 可以在这里做一些处理
      // if (!visible) {
      //   // 重置搜索状态
      //   this.pageParams.keyword = ''
      // }
    },
    remoteMethod(query) {
      // 防抖处理
    
      if(query){
          clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.pageParams.name = query;
        this.msgUserList = [];
        this.pageParams.page = 1;
        this.getUserList(true,'search');
      }, 300);
      }else{
        this.msgUserList =   this.selectedUser
        this.pageParams.page = 1;
        this.pageParams.name = query;
         this.getUserList(true);
      }
      
    },

    // 初始加载
    handleFocus() {
      if (this.msgUserList.length === 0) {
        this.getUserList(true);
      }
    },

    // 加载更多
    loadMore() {
      if (this.loadingMore || !this.hasMore) return;

      this.loadingMore = true;
      this.pageParams.page++;
      this.getUserList(false);
    },
    screenTrend() {
      if (this.trendPitch == "user") {
        this.getUserTrend();
      } else if (this.trendPitch == "visitor") {
        this.getVisitorTrend();
      }
    },
    // 渲染折线图
    render(data) {
      let myChart = this.$echarts.init(document.getElementById("trendCharts"));
      var option;

      var xData = [];
      var yData = [];

      data.forEach((item, index) => {
        // console.log(item)
        xData.push(item.date);
        yData.push(item.nums);
      });

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: xData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yData,
            type: "line",
          },
        ],
      };

      myChart.setOption(option);
    },
    // 获取访客趋势
    getVisitorTrend() {
      visitorTrend(this.trendForm).then((res) => {
        this.render(res.data);
      });
    },
    // 获取员工增长趋势
    getUserTrend() {
      companyUserTrend(this.trendForm).then((res) => {
        this.render(res.data);
      });
    },
    // 类型切换
    cut(type) {
      this.trendPitch = type;
      if (type == "user") {
        this.getUserTrend();
      } else if (type == "visitor") {
        this.getVisitorTrend();
      }
    },
    // 企业画像
    trend(id) {
      this.trendForm.id = id;
      this.getUserTrend();
      this.trendVisible = true;
    },
    getUserList(isReset = false,type) {
      // if (isReset) {
      //   this.msgUserList = [];
      //   // this.loading = true
      // }
      companyUser(this.pageParams).then((res) => {
        // this.msgUserList = res.data.lists.data;
        if(type == 'search'){
          this.msgUserList  = res.data.lists.data;
        }
        if (isReset) {
          this.msgUserList = this.mergeArraysUniqueById(
            this.msgUserList,
            res.data.lists.data
          );
        } else {
          this.msgUserList = this.mergeArraysUniqueById(
            this.msgUserList,
            res.data.lists.data
          );
        }
        this.pageParams.total = res.data.lists.total;
        this.hasMore = this.msgUserList.length < res.data.lists.total;
        this.loading = false;
        this.loadingMore = false;
      });
    },
    mergeArraysUniqueById(arr1, arr2, idKey = "id") {
      // 使用 Map 来去重，保留最后一个出现的值
      const map = new Map();

      // 合并数组，后面的会覆盖前面的
      const combined = [...arr1, ...arr2];

      // 遍历并添加到 Map（id 作为 key，自动去重）
      combined.forEach((item) => {
        const key = item[idKey];
        map.set(key, item);
      });

      // 返回去重后的数组
      return Array.from(map.values());
    },
    // 楼层选择
    floorChange(e) {
      this.ruleForm.house = [];
      this.getHouse();
    },
    // 获取房间列表
    getHouse() {
      get_space_house_lists({
        park_id: this.$store.state.mainParkId,
        space_id: this.ruleForm.space.toString(),
        space_floor_id: this.ruleForm.floor.toString(),
        is_page: 2,
      }).then((res) => {
        this.houseList = res.data.lists;
      });
    },
    spaceChange(e) {
      this.ruleForm.floor = [];
      this.ruleForm.house = [];
      this.getFloor();
    },
    // 获取楼层列表
    getFloor() {
      get_space_floor_lists({
        park_id: this.$store.state.mainParkId,
        space_id: this.ruleForm.space.toString(),
        is_page: 2,
      }).then((res) => {
        this.floorList = res.data.lists;
      });
    },
    parkChange(e) {
      this.ruleForm.space = [];
      this.ruleForm.floor = [];
      this.ruleForm.house = [];
      this.getSpace();
    },
    // 获取楼栋列表
    getSpace() {
      get_space_lists({
        park_id: this.$store.state.mainParkId,
        is_page: 2,
      }).then((res) => {
        this.spaceList = res.data.lists;
      });
    },

    zjson() {
      let data = {};
      this.ruleForm.space.forEach((item) => {
        data[item] = {};
      });
      this.ruleForm.floor.forEach((floorItem) => {
        this.floorList.forEach((item, index) => {
          if (item.id == floorItem) {
            if (data.hasOwnProperty(item.space_id)) {
              data[item.space_id][floorItem] = [];
            }
          }
        });
      });
      this.ruleForm.house.forEach((houseItem, houseIndex) => {
        this.houseList.forEach((item, index) => {
          if (item.id == houseItem) {
            if (data.hasOwnProperty(item.space_id)) {
              if (data[item.space_id].hasOwnProperty(item.space_floor_id)) {
                data[item.space_id][item.space_floor_id].push(item.id);
              }
            }
          }
        });
      });
      return data;
    },

    // 人脸识别
    faceHandleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        // if (this.userForm.face_url) {
        //   this.delImg(this.userForm.face_url);
        // }
        this.faceFileList.push({ url: this.imageOss + res.data.url });
        this.userForm.face_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.faceFileList = list;
      }
    },
    // 人脸识别删除
    faceHandleRemove(file) {
      this.faceFileList = [];
      this.userForm.face_url = "";
    },
    // 人脸识别上传限制
    faceBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
        return false;
      }
      return isLt5M;
    },
    handleRemove(file) {
      this.fileList = [];
      this.ruleForm.avatar_url = "";
    },
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    // 上传成功
    handleAvatarSuccessFile(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "2000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUploadFile(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      company_template().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    roleChange(e, index) {
      if (e.length) {
        this.domains[index].system_role_id = e[0];
      } else {
        this.domains[index].system_role_id = "";
      }
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        name: "",
        id: "",
        legal_name: "",
        company_mobile: "",
        company_contacts: "",
        legal_phone: "",
      };
      if (this.userInfo.company_id !== 0) {
        this.screen.id = this.userInfo.company_id;
      } else {
        this.screen.id = "";
      }
      this.fetchData();
    },
    // 提交
    editUserForm(formName) {
      var that = this;
      this.domains.forEach((item) => {
        if (item.company_id && item.system_role_id) {
        } else {
          this.$message({
            message: "企业角色未填写完整！",
            type: "warning",
          });
          return;
        }
      });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.userForm.company_role_data = JSON.stringify(that.domains);
              editCompanyUser(that.userForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.addUserDrawer = false;
                  that.getUser();
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    seeUserInfo(id) {
      var that = this;
      var data = {
        id,
        park_id: this.qiyeInfo.park_id,
        company_id: this.qiyeInfo.id,
      };
      companyUserInfo(data).then((res) => {
        this.userForm = {
          password: "",
          id: res.data.info.id,
          phone: res.data.info.phone,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          status: res.data.info.status,
          avatar_url: res.data.info.avatar_url,
          sex:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.sex
              : 3,
          age:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.age
              : 0,
          education:
            res.data.info.user_extend !== null
              ? res.data.info.user_extend.education
              : "",
          face_url: "",
        };
        that.domains = [];
        this.fileList = [];
        this.faceFileList = [];
        if (res.data.info.avatar_url) {
          this.fileList.push({ url: this.imageOss + res.data.info.avatar_url });
        }
        var list = res.data.info.user_park_company_rel;
        this.faceFileList = [];
        // if (res.data.info.face.length > 0) {
        //   console.log(58555)
        //   res.data.info.face.forEach((item, index) => {
        //     if (index == 0) {
        //       this.userForm.face_url = item.image;
        //     }
        //     this.faceFileList.push({ url: this.imageOss + item.image });
        //   });
        // }
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            that.domains.push({
              park_id: list[i].park_id || "",
              company_id: list[i].id != 0 ? list[i].id : "",
              system_role_id: list[i].system_role_id,
            });
          }
        }
        this.userType = "userSee";
        this.userDrawerTitle = "查看用户";
        this.addUserDrawer = true;
      });
    },
    // 删除
    userDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delCompanyUser({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getUser();
          });
        })
        .catch(() => {});
    },
    // 提交
    submitUserForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var chone = 0;
          this.domains.forEach((item) => {
            if (item.company_id && item.system_role_id) {
            } else {
              this.$message({
                message: "企业角色未填写完整！",
                type: "warning",
              });
              chone++;
              return;
            }
          });
          if (chone != 0) {
            return;
          }
          this.$confirm("确认提交？")
            .then(() => {
              const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
              });
              that.userForm.company_role_data = JSON.stringify(that.domains);
              addCompanyUser(that.userForm).then((res) => {
                loading.close();
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.addUserDrawer = false;
                  that.getUser();
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    // 添加
    addQiYeUser() {
      this.userForm = {
        phone: "",
        name: "",
        park_id: "",
        company_role_data: "",
        status: 1,
        avatar_url: "",
        age: 0,
        sex: 3,
        education: "",
        type: 2,
        password: "",
        face_url: "",
      };
      this.fileList = [];
      this.faceFileList = [];
      this.$nextTick(() => {
        this.$refs.userForm.clearValidate();
      });
      // this.userForm.park_id = this.qiyeInfo.park_id
      // this.domains[0].company_id = this.qiyeInfo.id
      this.addUserDrawer = true;
      this.domains = [
        {
          park_id: this.qiyeInfo.park_id,
          company_id: this.qiyeInfo.id,
          system_role_id: "",
        },
      ];
      this.userType = "add";
      this.userDrawerTitle = "添加用户";
    },
    // 获取企业
    getCompany(id) {
      openCompany({ park_id: id, is_page: 2 }).then((response) => {
        this.companyList = response.data.lists;
      });
    },
    // 获取角色
    getrole(type) {
      const data = {
        is_page: 2,
        is_tree: 2,
        type: type == 1 ? 2 : 1,
        role_type: 2,
        park_id: this.qiyeInfo.park_id,
        company_id: "",
      };
      openRole(data).then((res) => {
        this.roleList = this.globalfunc.getTreeData(res.data.lists);
      });
    },
    // 添加企业用户
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    handleAvatarSuccess(res, file) {
      // if (res.code === 200) {
      //   if (this.userForm.avatar_url) {
      //     this.delImg(this.userForm.avatar_url);
      //   }
      //   this.userForm.avatar_url = res.data.url;
      // }
      if (res.code === 200) {
        // if (this.ruleForm.avatar_url) {
        //   this.delImg(this.ruleForm.avatar_url);
        // }
        this.fileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.avatar_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    seeUser(val) {
      this.fileList = [];
      this.faceFileList = [];
      this.userScreen.id = val.id;
      this.qiyeInfo = {
        park_id: val.park_id,
        id: val.id,
      };
      this.getCompany(this.qiyeInfo.park_id);
      this.getrole(val.type);
      this.getUser();
      this.userDrawer = true;
    },
    getUser() {
      this.listLoading = true;
      companyUser(this.userScreen).then((res) => {
        this.userList = res.data.lists.data;
        this.userTotal = res.data.lists.total;
        this.listLoading = false;
      });
    },
    userHandleSize(val) {
      this.userScreen.page_size = val;
      this.getUser();
    },
    userHandleCurrent(val) {
      this.userScreen.page = val;
      this.getUser();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                id: that.ruleForm.id,
                name: that.ruleForm.name,
                park_id: that.ruleForm.park_id,
                legal_name: that.ruleForm.legal_name,
                legal_phone: that.ruleForm.legal_phone,
                company_mobile: that.ruleForm.company_mobile,
                company_contacts: that.ruleForm.company_contacts,
                about: that.ruleForm.about,
                status: that.ruleForm.status,
                type: that.ruleForm.type,
                // space_id: JSON.stringify(that.zjson()),
                accept_msg_user_id:
                  that.ruleForm.accept_msg_user_id.length > 0
                    ? that.ruleForm.accept_msg_user_id.join()
                    : "",
                //     type:that.ruleForm.type
              };
              editCompany(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.floorList = [];
      this.houseList = [];
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      this.pageParams.id = val.id;
      this.loadingMore = false;
      this.pageParams.page = 1;
      this.msgUserList = [];
      this.getUserList(val.id);
      this.getInfo(val.id);
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.pageParams.id = val.id;
      this.loadingMore = false;
      this.msgUserList = [];
      this.pageParams.page = 1;
      this.getInfo(val.id);
      this.getUserList(val.id);
      this.drawer = true;
    },
    getInfo(id) {
      infoCompany({ id: id }).then((res) => {
        this.ruleForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          legal_name: res.data.info.legal_name,
          legal_phone: res.data.info.legal_phone,
          company_mobile: res.data.info.company_mobile,
          company_contacts: res.data.info.company_contacts,
          about: res.data.info.about,
          status: res.data.info.status,
          space: res.data.info.space_id,
          floor: res.data.info.space_floor_id,
          house: res.data.info.space_house_id,
          accept_msg_user_id: [],
          type: res.data.info.type,
        };
        if (res.data.info.accept_user_lists.length > 0) {
          this.msgUserList = this.mergeArraysUniqueById(
            res.data.info.accept_user_lists,
            this.msgUserList
          ); 
          this.selectedUser = res.data.info.accept_user_lists
          res.data.info.accept_user_lists.forEach((item) => {
            // this.msgUserList.push(item);
            this.ruleForm.accept_msg_user_id.push(item.id);
          });
        }
        // this.getSpace();
        // if(res.data.info.space_id.length > 0){
        //   this.getFloor();
        // }
        // if(res.data.info.space_floor_id.length > 0){
        //   this.getHouse();
        // }
        this.oldImg = res.data.avatar_url;
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate(); // 只清除清除验证
        });
      });
    },
    // 查看角色
    openUserRole(id) {
      var data = {
        user_id: id,
        park_id: this.qiyeInfo.park_id,
        company_id: this.qiyeInfo.id,
        source: 2,
      };
      miniUserRole(data).then((res) => {
        this.userRoleData = res.data.lists;
        this.userRoleVisible = true;
      });
    },
    handleDelete(val) {
      const data = {
        id: val.user_id,
        role_id: val.system_role_id,
        park_id: val.park_id,
        company_id: val.company_id,
      };
      this.$confirm("确认删除？")
        .then(() => {
          delCompanyUser(data).then((res) => {
            // this.openUserRole(val.id);
            this.userRoleVisible = false;
            this.getUser();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                name: that.ruleForm.name,
                park_id: this.$store.state.mainParkId,
                legal_name: that.ruleForm.legal_name,
                legal_phone: that.ruleForm.legal_phone,
                company_mobile: that.ruleForm.company_mobile,
                company_contacts: that.ruleForm.company_contacts,
                about: that.ruleForm.about,
                status: that.ruleForm.status,
                type: that.ruleForm.type,
              };
              addCompany(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加企业";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        park_id: "",
        legal_name: "",
        legal_phone: "",
        company_mobile: "",
        company_contacts: "",
        about: "",
        status: 1,
        space: [],
        floor: [],
        house: [],
        type: 1,
      };
      this.drawer = true;
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_id = this.userInfo.park_id;
      //   this.getSpace();
      // }
      this.ruleForm.space = [];
      this.ruleForm.floor = [];
      this.ruleForm.house = [];
      this.getSpace();

      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delCompany(type, id) {
      var that = this;
      var ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        if (this.multipleSelection.length) {
          this.multipleSelection.forEach((item, index) => {
            ids.push(item.id);
          });
        } else {
          this.$message.error("至少选择一个用户");
          return;
        }
      }
      this.$confirm("确认删除？")
        .then(() => {
          delCompany({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      companyList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    margin-bottom: 10px;
  }
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.qyUser {
  ::v-deep .el-drawer__body {
    padding: 0 20px;
  }
}
.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 5px 5px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}
.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.tabBox {
  width: 100px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  border-radius: 6px;
  margin-right: 20px;
}
.pitch {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}
::v-deep .trendDialog {
  .el-dialog__header {
    padding: 20px 20px 0px;
  }
  .el-dialog__body {
    padding: 15px 20px;
  }
}

.load-more-option,
.no-more-option,
.empty-option {
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  color: #909399;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}

.load-more-option:hover {
  background-color: #f5f7fa;
}

.loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.loading-text .el-icon-loading {
  color: #409eff;
  font-size: 16px;
}

.load-more-text {
  color: #409eff;
  transition: color 0.3s;
}

.load-more-text:hover {
  color: #66b1ff;
}

.no-more-option {
  color: #c0c4cc;
  cursor: default;
}
</style>
